// downloads/actionTypes.js

const REQUEST_SEASON_HIGHS_GOALS_FOR_DATA = '@@seasonHighs/REQUEST_SEASON_HIGHS_GOALS_FOR_DATA';
const SEASON_HIGHS_GOALS_FOR_RESPONSE = '@@seasonHighs/SEASON_HIGHS_GOALS_FOR_RESPONSE';

const REQUEST_SEASON_HIGHS_SHOTS_DATA = '@@seasonHighs/REQUEST_SEASON_HIGHS_SHOTS_DATA';
const SEASON_HIGHS_SHOTS_RESPONSE = '@@seasonHighs/SEASON_HIGHS_SHOTS_RESPONSE';

const REQUEST_SEASON_HIGHS_PIM_DATA = '@@seasonHighs/REQUEST_SEASON_HIGHS_PIM_DATA';
const SEASON_HIGHS_PIM_RESPONSE = '@@seasonHighs/SEASON_HIGHS_PIM_RESPONSE';

const REQUEST_SEASON_HIGHS_PPG_DATA = '@@seasonHighs/REQUEST_SEASON_HIGHS_PPG_DATA';
const SEASON_HIGHS_PPG_RESPONSE = '@@seasonHighs/SEASON_HIGHS_PPG_RESPONSE';

const REQUEST_SEASON_HIGHS_PLAYER_GOALS_DATA = '@@seasonHighs/REQUEST_SEASON_HIGHS_PLAYER_GOALS_DATA';
const SEASON_HIGHS_PLAYER_GOALS_RESPONSE = '@@seasonHighs/SEASON_HIGHS_PLAYER_GOALS_RESPONSE';

const REQUEST_SEASON_HIGHS_PLAYER_ASSISTS_DATA = '@@seasonHighs/REQUEST_SEASON_HIGHS_PLAYER_ASSISTS_DATA';
const SEASON_HIGHS_PLAYER_ASSISTS_RESPONSE = '@@seasonHighs/SEASON_HIGHS_PLAYER_ASSISTS_RESPONSE';

const REQUEST_SEASON_HIGHS_PLAYER_POINTS_DATA = '@@seasonHighs/REQUEST_SEASON_HIGHS_PLAYER_POINTS_DATA';
const SEASON_HIGHS_PLAYER_POINTS_RESPONSE = '@@seasonHighs/SEASON_HIGHS_PLAYER_POINTS_RESPONSE';

const REQUEST_SEASON_HIGHS_PLAYER_PPG_DATA = '@@seasonHighs/REQUEST_SEASON_HIGHS_PLAYER_PPG_DATA';
const SEASON_HIGHS_PLAYER_PPG_RESPONSE = '@@seasonHighs/SEASON_HIGHS_PLAYER_PPG_RESPONSE';

const REQUEST_SEASON_HIGHS_PLAYER_SHOTS_DATA = '@@seasonHighs/REQUEST_SEASON_HIGHS_PLAYER_SHOTS_DATA';
const SEASON_HIGHS_PLAYER_SHOTS_RESPONSE = '@@seasonHighs/SEASON_HIGHS_PLAYER_SHOTS_RESPONSE';

const REQUEST_SEASON_HIGHS_PLAYER_PIM_DATA = '@@seasonHighs/REQUEST_SEASON_HIGHS_PLAYER_PIM_DATA';
const SEASON_HIGHS_PLAYER_PIM_RESPONSE = '@@seasonHighs/SEASON_HIGHS_PLAYER_PIM_RESPONSE';

const REQUEST_SEASON_HIGHS_PLAYER_TOI_DATA = '@@seasonHighs/REQUEST_SEASON_HIGHS_PLAYER_TOI_DATA';
const SEASON_HIGHS_PLAYER_TOI_RESPONSE = '@@seasonHighs/SEASON_HIGHS_PLAYER_TOI_RESPONSE';

const REQUEST_SEASON_HIGHS_GOALIE_SHOTS_AGAINST_DATA = '@@seasonHighs/REQUEST_SEASON_HIGHS_GOALIE_SHOTS_AGAINST_DATA';
const SEASON_HIGHS_GOALIE_SHOTS_AGAINST_RESPONSE = '@@seasonHighs/SEASON_HIGHS_GOALIE_SHOTS_AGAINST_RESPONSE';

const REQUEST_SEASON_HIGHS_GOALIE_SAVES_DATA = '@@seasonHighs/REQUEST_SEASON_HIGHS_GOALIE_SAVES_DATA';
const SEASON_HIGHS_GOALIE_SAVES_RESPONSE = '@@seasonHighs/SEASON_HIGHS_GOALIE_SAVES_RESPONSE';

export default {
    REQUEST_SEASON_HIGHS_GOALS_FOR_DATA,
    SEASON_HIGHS_GOALS_FOR_RESPONSE,
    REQUEST_SEASON_HIGHS_SHOTS_DATA,
    SEASON_HIGHS_SHOTS_RESPONSE,
    REQUEST_SEASON_HIGHS_PIM_DATA,
    SEASON_HIGHS_PIM_RESPONSE,
    REQUEST_SEASON_HIGHS_PPG_DATA,
    SEASON_HIGHS_PPG_RESPONSE,

    REQUEST_SEASON_HIGHS_PLAYER_GOALS_DATA,
    SEASON_HIGHS_PLAYER_GOALS_RESPONSE,
    REQUEST_SEASON_HIGHS_PLAYER_ASSISTS_DATA,
    SEASON_HIGHS_PLAYER_ASSISTS_RESPONSE,
    REQUEST_SEASON_HIGHS_PLAYER_POINTS_DATA,
    SEASON_HIGHS_PLAYER_POINTS_RESPONSE,
    REQUEST_SEASON_HIGHS_PLAYER_PPG_DATA,
    SEASON_HIGHS_PLAYER_PPG_RESPONSE,
    REQUEST_SEASON_HIGHS_PLAYER_SHOTS_DATA,
    SEASON_HIGHS_PLAYER_SHOTS_RESPONSE,
    REQUEST_SEASON_HIGHS_PLAYER_PIM_DATA,
    SEASON_HIGHS_PLAYER_PIM_RESPONSE,
    REQUEST_SEASON_HIGHS_PLAYER_TOI_DATA,
    SEASON_HIGHS_PLAYER_TOI_RESPONSE,

    REQUEST_SEASON_HIGHS_GOALIE_SHOTS_AGAINST_DATA,
    SEASON_HIGHS_GOALIE_SHOTS_AGAINST_RESPONSE,
    REQUEST_SEASON_HIGHS_GOALIE_SAVES_DATA,
    SEASON_HIGHS_GOALIE_SAVES_RESPONSE


};